import AWS from "../auth/aws/AWS";
import GoogleAnalyticsQuery from "../query/GoogleAnalyticsQuery";
import InvokeFields from "../util/InvokeFields";
import DashboardDateUtil from "../util/DashboardDateUtil";

export default class GoogleAnalyticsDataAccess {

    public static USERSESSIONS = "googleAnalyticsUserSession";
    public static TRAFFICSOURCES = "googleAnalyticsTrafficSources";
    public static PAGEVIEWS = "googleAnalyticsPageViews";

    public static USERSESSIONS_USERS = "users";
    public static USERSESSIONS_NEWUSERS = "newUsers";
    public static USERSESSIONS_SESSIONS = "sessions";
    public static USERSESSIONS_BOUNCES = "bounces";
    public static USERSESSIONS_BOUNCERATE = "bounceRate";
    public static USERSESSIONS_SESSIONDURATION = "sessionDuration";
    public static USERSESSIONS_AVGSESSIONDURATION = "avgSessionDuration";

    public static TRAFFICSOURCES_SOURCE = "source";
    public static TRAFFICSOURCES_MEDIUM = "medium";
    public static TRAFFICSOURCES_VISITS = "visits";

    public static PAGEVIEWS_PAGEPATH = "pagePath";
    public static PAGEVIEWS_PAGEVIEWS = "pageviews";
    public static PAGEVIEWS_UNIQUEPAGEVIEWS = "uniquePageviews";
    public static PAGEVIEWS_AVGTIMEONPAGE = "avgTimeOnPage";

    public userSessions:Array<GoogleAnalyticsUserSessionReport> = [];
    public trafficSources:Array<GoogleAnalyticsTrafficSourcesReport> = [];
    public pageViews:Array<GoogleAnalyticsPageViewsReport> = [];

    public async fetchData(projectId:string, timeInterval:TimeInterval):Promise<any> {
        this.getGoogleAnalyticsUserSessions(projectId, timeInterval);
        this.getGoogleAnalyticsTrafficSources(projectId, timeInterval);
        this.getGoogleAnalyticsPageViews(projectId, timeInterval);
    }

    public async getGoogleAnalyticsUserSessions(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        let input:ReportInput = {
            field: InvokeFields.getGoogleAnalyticsUserSessions,
            dataSourceId: dataSourceId,
            fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
            toDate: timeInterval.end,
            interval: DashboardDateUtil.getDateInterval(timeInterval.interval)
        };

        var self = this;
        return new Promise(async function(resolve) {
            self.userSessions = await AWS.query(GoogleAnalyticsQuery.GetGoogleAnalyticsUserSessions, {input: input});
            console.log(self.userSessions);
            resolve(self.userSessions);
        });
    }

    public async getGoogleAnalyticsTrafficSources(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        let input:ReportInput = {
            field: InvokeFields.getGoogleAnalyticsTrafficSources,
            dataSourceId: dataSourceId,
            fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
            toDate: timeInterval.end,
            interval: DashboardDateUtil.getDateInterval(timeInterval.interval)
        };

        var self = this;
        return new Promise(async function(resolve) {
            self.trafficSources = await AWS.query(GoogleAnalyticsQuery.GetGoogleAnalyticsTrafficSources, {input: input});
            console.log(self.userSessions);
            resolve(self.userSessions);
        });
    }

    public async getGoogleAnalyticsPageViews(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        let input:ReportInput = {
            field: InvokeFields.getGoogleAnalyticsPageViews,
            dataSourceId: dataSourceId,
            fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
            toDate: timeInterval.end,
            interval: DashboardDateUtil.getDateInterval(timeInterval.interval)
        };

        var self = this;
        return new Promise(async function(resolve) {
            self.pageViews = await AWS.query(GoogleAnalyticsQuery.GetGoogleAnalyticsPageViews, {input: input});
            console.log(self.userSessions);
            resolve(self.userSessions);
        });
    }

    public clearData() {
        this.userSessions = [];
        this.trafficSources = [];
        this.pageViews = [];
    }
}